import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	loading: {
		id: 'project-create-importer-upload-flow.mapping-screen.mapping-table.loading',
		defaultMessage: 'One moment while we get this ready...',
		description: 'Description for the loading state',
	},
	error: {
		id: 'project-create-importer-upload-flow.mapping-screen.mapping-table.error',
		defaultMessage: "We're having some trouble with this file",
		description: 'Description for the error state',
	},
	retry: {
		id: 'project-create-importer-upload-flow.mapping-screen.mapping-table.retry',
		defaultMessage: 'Try again',
		description: 'Button text to retry reading the file again',
	},
	preview: {
		id: 'project-create-importer-upload-flow.mapping-screen.mapping-table.preview',
		defaultMessage: 'Previewing first 30 tasks',
		description:
			'Message to tell the user that the table is only showing the first 30 items of the CSV file',
	},
});
